module.exports = __webpack_public_path__ + "static/GoforthNewestHeadshot-0727197beffd3808308d0ea22f363ce1.jpg";